import { doc, getDoc } from "firebase/firestore";
import { db } from "../../helpers/firebase";

const CPA_COLLECTION = "cpa";

/**
 * Fetch CPA by document ID from Firestore.
 * Document may have: company, email, phone, name, website, address, etc.
 * @param {string} cpaId - Document ID in cpa collection (e.g. "paytongillis")
 * @returns {Promise<{ id: string, company?: string, email?: string, phone?: string, name?: string, website?: string, address?: string } | null>}
 */
export async function getCpaById(cpaId) {
  if (!cpaId || typeof cpaId !== "string" || !cpaId.trim()) {
    return null;
  }
  const id = cpaId.trim().toLowerCase();
  try {
    const docRef = doc(db, CPA_COLLECTION, id);
    const docSnap = await getDoc(docRef);
    if (!docSnap.exists()) {
      return null;
    }
    const data = docSnap.data();
    return {
      id: docSnap.id,
      company: data?.company ?? null,
      email: data?.email ?? null,
      phone: data?.phone ?? null,
      name: data?.name ?? null,
      website: data?.website ?? null,
      address: data?.address ?? null,
      credentials: data?.credentials ?? null,
      description: data?.description ?? null,
    };
  } catch (error) {
    console.error("Error fetching CPA:", error);
    return null;
  }
}
